import defaultTheme from "./themedefault";
import clone from "clone";

const theme = clone(defaultTheme);

theme.themeName = "azetTheme";

// Sidebar
theme.sidebar = {
  buttonColor: "#00202B",
  backgroundColor: "#00202B",
  textColor: "#ffffff"
};

// Sidebar
theme.topbar = {
  buttonColor: "#00202B",
  backgroundColor: "#ffffff",
  textColor: "#000000"
};

export default theme;
